<template>
    <v-container>

        <v-checkbox v-model="formActive" color="#c42111" :label="'Selected Parameters(s)'" @change="onChange" />
        <v-row>
            <v-col>
                <v-autocomplete v-model="selected" @update:filtered-items="(v) => {filteredItems = v}" return-object :multiple="true" :items="items" @change="onChange" :placeholder="searchText" :disabled="!formActive" :rules="[validation.required(formActive, selected)]">
                    <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggleSelectAllFiltered">
                            <v-list-item-action>
                                <v-icon>{{filteredItemsIcon}}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{matchingResultsText}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:selection="{ item, index }">
                        <span v-if="index === 0">{{ item.text }}</span>
                        <span v-if="index === 1" class="grey--text caption"> (+{{ selected.length - 1 }} others)</span>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col v-if="secondaryItems.length">
                <v-autocomplete v-model="secondarySelected" :multiple="true" :items="secondaryItems" @change="onChange" :disabled="!formActive" />
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
export default {
    name: 'ParameterSelect',
    props: ['param'],
    data: () => ({
        formActive: false,
        selected: [],
        items: [],
        searchText: "",
        secondaryItems: [],
        secondarySelected: [],
        validation: {
            required: (formActive, selected) => (!formActive || selected.length > 0) || `You must select at least one parameter`
        },
        filteredItems: []
    }),

    computed: {
        allFilteredItemsSelected() {
            return (this.filteredItems.every(item => {
                return this.selected.some(s => s.value == item.value);
            }));
        },

        matchingResultsText() {
            return (this.allFilteredItemsSelected) ? "Unselect All Matching Results" : "Select All Matching Results";
        },

        filteredItemsIcon() {
            return (this.allFilteredItemsSelected) ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline";
        }
    },

    methods: {
        onChange: function(val) {
            let selectedValue = '';
            let humanText = '';
            if(this.formActive) {
                selectedValue = '1';
            }
            else {
                this.param.selectedValue = '0 0 0';
                this.param.humanText = 'All parameters';
                return;
            }

            selectedValue += ` `;

            if(this.selected.length) {
                for(let item of this.selected) {
                    selectedValue += `${item.value};`;
                    humanText += `${item.text}, `;
                }
                selectedValue = selectedValue.slice(0, -1);
            }
            else {
                selectedValue += `0`;
            }

            selectedValue += ` `;

            if(this.secondarySelected.length) {
                for(let item of this.secondarySelected) {
                    selectedValue += `${this.secondaryItems.indexOf(item) + 1};`;
                    humanText += `${item}, `;
                }
                selectedValue = selectedValue.slice(0, -1);
            }
            else {
                selectedValue += `0`;
            }
            humanText = humanText.slice(0, -2);
            
            this.param.selectedValue = selectedValue;
            this.param.humanText = humanText;

            this.$emit('edit');
        },

        buildForm: function() {
            let formArr = [[],[],[],[],[]];

            let list = this.param.rpt_param_values.slice(0);
            let inner = 0;
            for(let i = 0; i < list.length; i++) {
                let item = list[i];
                if(item !== "") {
                    formArr[inner].push(item);
                }
                else {
                    inner += 1;
                }
            }

            this.formActive = (formArr[0][0].toLowerCase() == 'true');
            for(let [idx, item] of formArr[1].entries()) {
                this.items.push({
                    text: item,
                    value: formArr[2][idx]
                })
            }
            this.searchText = formArr[3][0];
            this.secondaryItems = formArr[4];
        },

        setInputsInitialValue: function() {
            if(this.$props.param.encodedValue == undefined) {
                return;
            }
            const value = this.$props.param.encodedValue.split(' ');
            if(value[0] == '0') {
                return;
            }
            this.formActive = true;
            const selectedItems = value[1].split(';');
            for(const s of selectedItems) {
                for(const item of this.items) {
                    if(s == item.value) {
                        this.selected.push(item);
                    }
                }
            }

            selectedItems = value[2].split(';');
            for(const s of selectedItems) {
                for(const item of this.secondaryItems) {
                    if(s == item.value) {
                        this.secondarySelected.push(item);
                    }
                }
            }
        },

        toggleSelectAllFiltered: function() {
            // Select All
            if(this.allFilteredItemsSelected) {
                // We need to deselect all filtered items
                this.selected = this.selected.filter(s => {
                    return (!this.filteredItems.some(item => s.value == item.value));
                })
            }
            else {
                // We need to select all filtered items
                for(const item of this.filteredItems) {
                    if(!this.selected.some(s => s.value == item.value)) {
                        this.selected.push(item);
                    }
                }
            }
            this.onChange();
        },

    },

    mounted() {
        this.buildForm();
        this.setInputsInitialValue();
        this.onChange();
    }

  
};
</script>

<style scoped>


</style>

